var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-textarea',{staticClass:"questionText",attrs:{"rows":2,"counter":"1000","filled":"","label":_vm.labelText,"disabled":_vm.disabled,"max":1000,"maxlength":"1000","rules":!_vm.isSubtitle
      ? [
          function (v) { return !!(v ? v.trim() : '') ||
            (_vm.requiredMessage != null
              ? _vm.requiredMessage
              : _vm.$t('widget.fieldRequired')); },
          function (v) { return _vm.regExp.test(v) ||
            (_vm.validationMessage != null ? _vm.validationMessage : _vm.$t('widget.fieldInvalid')); },
            function (v) { return v.length <= 1000 || this$1.$t('ruleQuestionMaxLength'); }
        ]
      : [],"required":!_vm.isSubtitle},model:{value:(_vm.text),callback:function ($$v) {_vm.text=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"text"}})}
var staticRenderFns = []

export { render, staticRenderFns }